<div class="container-fluid bg-blue">
        <div class="row padding justify-content-center">
            ©2000 - 2022 by goExpats.com All rights reserved.
        </div>
        <div class="row padding text-center">
            <div>
                <a href="https://beian.mps.gov.cn/#/query/webSearch?code=12011202000842 " target="_blank" class="text-white padding-left">
                    <img src="https://www.goexpats.com/medias/iconeTJ.png" width="36px" height="auto" style="max-width: 36px; height: auto;"> 津公网安备12011202000842
                </a>
                <a href="https://beian.miit.gov.cn" class="text-white padding-left">津ICP备18008001号-1</a>
            </div>
        </div>
    </div>